export default "__VITE_ASSET__0b61426b__"